import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const Program = () => {
  const location = useLocation();

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 아소비 프로그램`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });
  }, [location]);

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/philosophy">아소비 이념</a>
              </li>
              <li>
                <a href="/learning">특허받은 학습법</a>
              </li>
              <li>
                <a href="/program" className="sel">
                  아소비 프로그램
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="program">
          <div className="sect program01">
            <div className="wrap">
              <div className="tit init">
                유기농공부가 <br className="mo-view" />
                튼튼한 열매를 맺기까지
              </div>
              <div className="txt init">
                몸과 마음이 모두 건강한 아이를 만들고자{" "}
                <br className="mo-view" /> 아소비만의 프로그램을 통해{" "}
                <br className="pc-view" />
                4차 산업혁명 시대가 요구하는 <br className="mo-view" />
                미래형 인재의 기반을 세워줍니다.
              </div>
            </div>
          </div>
          <div className="sect program02">
            <div className="desc">
              <div className="wrap">
                <div className="tit init">학습생명력 키우기 프로그램</div>
                <div className="txt init">
                  스스로 공부하는 힘인 학습생명력을 키워 주기 위해 아소비는{" "}
                  <br />
                  체계적이고 독창적인 프로그램을 구성해 아이의 공부 자신감을
                  키워줍니다.
                </div>
                <div className="step">
                  <div className="img">
                    <img
                      src="../custom-resources/img/img_program_program02_img01.png"
                      alt=""
                    />
                    <p>STEP 01</p>
                  </div>
                  <div className="con init">
                    <strong>베이직 과정</strong>
                    <span>기초 개념을 다루는 가장 첫 단계</span>
                    <p>
                      다양한 감각교구와 창의교구를 활용하여 <br />
                      쉽게 놀이하듯 만지고 체험하며 기초 개념을 <br /> 배웁니다.
                      <br />
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="desc">
              <div className="wrap">
                <div className="step">
                  <div className="img">
                    <img
                      src="../custom-resources/img/img_program_program02_img02.png"
                      alt=""
                    />
                    <p>STEP 02</p>
                  </div>
                  <div className="con init">
                    <strong>그로우 과정</strong>
                    <span>학습의 기본기를 다지는 단계</span>
                    <p>
                      아소비만의 특화된 교수법으로 한글, 수학, <br />
                      칠교, 한자 등 학습의 기본 개념을 이해하고 <br />
                      탄탄하게 다질 수 있습니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="desc">
              <div className="wrap">
                <div className="step">
                  <div className="img">
                    <img
                      src="../custom-resources/img/img_program_program02_img03.png"
                      alt=""
                    />
                    <p>STEP 03</p>
                  </div>
                  <div className="con init">
                    <strong>마스터 과정</strong>
                    <span>사고력과 창의력을 키우는 단계</span>
                    <p>
                      유아 심화 과정으로 기본 개념을 응용하여 <br />
                      확장시킬 수 있으며, 스스로 생각하는 힘과 <br /> 스스로
                      자신의 생각을 글과 그림으로 표현하는 힘을 기를 수
                      있습니다.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="desc">
              <div className="wrap">
                <div className="step">
                  <div className="img">
                    <img
                      src="../custom-resources/img/img_program_program02_img04.png"
                      alt=""
                    />
                    <p>STEP 04</p>
                  </div>
                  <div className="con init">
                    <strong>초등 과정</strong>
                    <span>초등 교과 연계를 통한 심화 학습</span>
                    <p>
                      교과별 핵심 개념과 원리를 이해하여 <br />
                      초등 학습에 잘 적응할 수 있도록 도움을 주며, <br />
                      점차 수준 높은 학습 이해력을 기를 수{" "}
                      <br className="pc-view" />
                      있습니다.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="sect program03">
            <div className="wrap">
              <div className="tit init">국어와 수학의 완전 학습</div>
              <div className="txt init">
                <b>아소비 국어</b>는 학교 교과의 핵심 개념을 배우고{" "}
                <br className="mo-view" /> <br className="pc-view" />
                논술과 한자 및 독해 훈련으로 심화학습이 가능하도록 도와줍니다.{" "}
                <br className="mo-view" /> <br className="pc-view" />
                <b>아소비 수학</b>은 쉽게 이해하는 개념 학습을 시작으로 논리
                학습과 <br /> 연산으로 문장제 문제와 서술형 문제에 대한 적응력을
                높입니다.
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Program;
